import { render, staticRenderFns } from "./DefaultPlayerSettings.vue?vue&type=template&id=ad624184&"
import script from "./DefaultPlayerSettings.vue?vue&type=script&lang=js&"
export * from "./DefaultPlayerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports